module.exports = __webpack_public_path__ + "static/abacus-3bfd463a9c9a289900c3296f2b2a54cf.png";